"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
exports.getID = function (path) {
    var _a = path.split('.').reverse(), featureId = _a[0], reversedInputPath = _a.slice(1);
    var inputId = reversedInputPath.reverse().join('.');
    return [featureId, inputId];
};
var isCallback = function (o) {
    return typeof o === 'function';
};
var isErrorLevel = function (o) {
    return typeof o !== 'function';
};
exports.throwError = function (err, levelOrCallback) {
    if (isCallback(levelOrCallback)) {
        levelOrCallback(err);
    }
    else if (isErrorLevel(levelOrCallback)) {
        switch (levelOrCallback) {
            case types_1.ErrorLevel.THROW:
                throw err;
            case types_1.ErrorLevel.ERROR:
                console.error(err);
                break;
            case types_1.ErrorLevel.WARN:
                console.warn(err);
                break;
            case types_1.ErrorLevel.NONE:
            default:
        }
    }
};
//# sourceMappingURL=utils.js.map